import React from "react";
import { Paper, BottomNavigation, BottomNavigationAction } from "@mui/material";

// Mobile bottom navigation bar, shown in place of relying solely on the drawer on small screens.
export const BottomNav = ({ activeView, setActiveView, sidebarItems, darkMode, theme }) => (
  <Paper
    elevation={8}
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.appBar,
      bgcolor: darkMode ? '#0E1626' : '#FFFFFF',
      borderTop: darkMode ? '1px solid #16213A' : '1px solid #EAF0F4',
    }}
  >
    <BottomNavigation
      showLabels
      value={activeView}
      onChange={(e, newValue) => setActiveView(newValue)}
      sx={{ bgcolor: 'transparent' }}
    >
      {sidebarItems.map((item) => (
        <BottomNavigationAction
          key={item.view}
          label={item.text}
          value={item.view}
          icon={item.icon}
          sx={{
            color: activeView === item.view ? theme.palette.primary.main : (darkMode ? '#5E6C87' : 'text.secondary'),
            '&.Mui-selected': { color: theme.palette.primary.main },
            minWidth: 0,
          }}
        />
      ))}
    </BottomNavigation>
  </Paper>
);

export default BottomNav;
